import baseAxios from 'axios';
import qs from 'qs';

const axios = baseAxios.create({
  baseURL: window.location.origin,
  paramsSerializer: params => { return qs.stringify(params) }
});

axios.interceptors.request.use(
  config => {
    let cfg = config;
    const controller = new AbortController();
    cfg.signal = controller.signal;
    if (useSystemStore().connection.value)
        controller.abort('requests cancelled');
    return cfg;
  },
);

axios.interceptors.response.use(
  response => {
    if (response.config.withoutInterceptor)
      return response;
    if (response.data.status == 'OK' || response.data.status == 'NOK' || response.data.status == 'CREATED' || response.data.status == 'UPDATED' || response.data.status == 'DELETED') {
        return response.data;
    }
  },
  error => {
    if (error.response) {
      if (error.response.data.status == 'NOT_FOUND') {
          router.push({path: '/404'});
      }
      if (error.response.data.status == 'EXPIRATION_ERROR') {
          router.push({path: '/expired'});
      }
      if (error.response.data.status == 'AUTORIZATION_ERROR') {
          router.push({path: '/403'})
      }
      if (error.response.data.status == 'SERVER_ERROR') {
          router.push({path: '/500'});
      }
      if (error.response.data.status == 'SYSTEM_SUSPENSION') {
          useSystemStore().setMaintenanceText(error.response.data.message);
          router.push({path: '/503'})
      }
      if (error.response.data.status == 'VALIDATION_ERROR') {
          if (error.response.data.errors && Array.isArray(error.response.data.errors))
              error.response.data.errors.forEach(element => {
                  useToastStore().error(element)
              });
          else
              useToastStore().error(error.response.data.message);
      }
      if (error.response.data.status == 'AUTHENTICATION_ERROR') {
          if (!useAuthStore().authError) {
              useAuthStore().logout();
              useToastStore().error(error.response.data.message)
          }
      }
  }
  }
);

export default axios;
